import React from "react";

const Bulk = () => {
  return (
    <div
      className="relative overflow-hidden py-14 px-6 sm:px-12 md:px-24"
      style={{
        background: "linear-gradient(135deg, var(--brand-primary-900) 0%, var(--brand-primary-700) 45%, var(--brand-primary-600) 100%)",
      }}
    >
      {/* Decorative glowing orbs */}
      <div
        className="absolute -top-16 -right-16 w-72 h-72 rounded-full opacity-20 pointer-events-none"
        style={{ background: "radial-gradient(circle, var(--brand-primary-200) 0%, transparent 70%)" }}
      />
      <div
        className="absolute -bottom-12 -left-12 w-56 h-56 rounded-full opacity-20 pointer-events-none"
        style={{ background: "radial-gradient(circle, var(--brand-primary-200) 0%, transparent 70%)" }}
      />
      {/* Subtle dot grid */}
      <div
        className="absolute inset-0 opacity-5 pointer-events-none"
        style={{
          backgroundImage: "radial-gradient(circle, #fff 1px, transparent 1px)",
          backgroundSize: "28px 28px",
        }}
      />

      {/* Content */}
      <div className="relative max-w-3xl mx-auto text-center flex flex-col items-center gap-4">

        {/* Headline */}
        <div>
          <h2
            className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight"
            style={{ fontFamily: "'Times New Roman', Serif" }}
          >
            We take Customized Tailoring Order Too
          </h2>
          <h3
            className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-semibold mt-1"
            style={{ fontFamily: "'Times New Roman', Serif", color: "var(--brand-primary-200)" }}
          >
            Customize Your Favourite Outfit
          </h3>
        </div>

        {/* Divider */}
        <div className="flex items-center gap-3">
          <div className="h-px w-10 bg-white/30" />
          <div className="w-1.5 h-1.5 rotate-45 bg-[var(--brand-primary-300)]" />
          <div className="h-px w-10 bg-white/30" />
        </div>

        {/* Description */}
        <p className="text-white/80 text-sm sm:text-base max-w-xl leading-relaxed">
          From Aavryaa it's so easy to get the dream customized outfit in perfect fit. Get your dream
          customized dress from our fabrics —{" "}
          <span className="text-[var(--brand-primary-200)] font-medium italic">U dream it, we customize it.</span>
        </p>

        {/* Feature pills */}
        <div className="flex flex-wrap justify-center gap-2">
          {[
            "Perfect Fit",
            "Custom Fabrics",
            "Video Consultation",
            "Exact Measurements",
          ].map((text) => (
            <span
              key={text}
              className="flex items-center gap-1.5 bg-white/10 border border-white/25 text-white text-xs font-medium px-4 py-1.5 rounded-full"
            >
              {text}
            </span>
          ))}
        </div>

        {/* CTA label */}
        <p className="text-[var(--brand-primary-200)] font-semibold text-xs sm:text-sm uppercase tracking-widest">
          Book a Video Call · Get Outfits Made to Your Exact Measurements
        </p>

        {/* CTA button */}
        <a
          href="https://wa.me/919789389489"
          target="_blank"
          rel="noopener noreferrer"
        >
          <button className="inline-flex items-center gap-2.5 bg-white text-[var(--brand-primary-700)] font-bold py-3 px-10 text-base rounded-full shadow-2xl hover:bg-[var(--brand-primary-50)] hover:scale-105 active:scale-95 transition-all duration-300">
            <svg className="w-4 h-4 fill-green-600" viewBox="0 0 24 24">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
              <path d="M12 0C5.373 0 0 5.373 0 12c0 2.138.564 4.14 1.541 5.875L0 24l6.299-1.519A11.956 11.956 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22c-1.86 0-3.607-.487-5.12-1.34L2 22l1.372-4.768A9.942 9.942 0 012 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z" />
            </svg>
            Customize Now
          </button>
        </a>
      </div>
    </div>
  );
};

export default Bulk;
